import React, { useMemo } from 'react';

const countWords = (text = '') =>
    text
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0)
        .length;

const TIME_OPTIONS = [
    { value: '10-15 min', label: '10 – 15 min', hint: 'Muy rápido' },
    { value: '15-20 min', label: '15 – 20 min', hint: 'Rápido' },
    { value: '20-30 min', label: '20 – 30 min', hint: 'Normal' },
    { value: '30-40 min', label: '30 – 40 min', hint: 'Con más elaboración' },
];

const StepRestaurantBasicInfo = ({ formData, onUpdate, errors = {}, onClearError }) => {
    const handleChange = (field, value) => {
        onUpdate({ [field]: value });
        if (errors[field] && onClearError) onClearError(field);
    };

    const wordCount = useMemo(
        () => countWords(formData.description || ''),
        [formData.description]
    );

    return (
        <div className="ro-body ro-basic">
            <div className="ro-step-hd">
                <span className="ro-eyebrow ro-eyebrow--accent">Paso 1 · Tu negocio</span>
                <h2 className="ro-title">Identidad del negocio</h2>
                <p className="ro-subtitle">
                    El nombre y la descripción son lo primero que verán tus clientes.
                </p>
            </div>

            {/* Nombre */}
            <div className="ro-field">
                <label className="ro-lbl">
                    Nombre del negocio<span className="ro-req">*</span>
                </label>

                <div className={`ro-inputwrap${errors.name ? ' ro-inputwrap--err' : ''}`}>
                    <span className="ro-inputico" aria-hidden>🏪</span>
                    <input
                        type="text"
                        className="ro-input--clean"
                        placeholder="Ej. El Horno de la Abuela"
                        value={formData.name || ''}
                        onChange={(e) => handleChange('name', e.target.value)}
                        maxLength={127}
                        autoComplete="organization"
                    />
                </div>

                {errors.name && <span className="ro-err-msg">{errors.name}</span>}
            </div>

            {/* Descripción */}
            <div className="ro-field">
                <label className="ro-lbl">
                    Descripción<span className="ro-req">*</span>
                </label>

                <div className={`ro-textareawrap${errors.description ? ' ro-textareawrap--err' : ''}`}>
          <textarea
              className="ro-textarea"
              placeholder="Ej. Elaboramos postres artesanales como cheesecakes y brownies gourmet, preparados con ingredientes de alta calidad."
              value={formData.description || ''}
              onChange={(e) => handleChange('description', e.target.value)}
              rows={4}
          />

                    <span
                        className={`ro-inputsuffix ro-textarea-count${
                            wordCount < 8 || wordCount > 15 ? ' ro-textarea-count--warn' : ''
                        }`}
                    >
            {wordCount} palabras
          </span>
                </div>

                {errors.description && <span className="ro-err-msg">{errors.description}</span>}

                <span className="ro-hint">
          Mínimo 8 palabras, máximo 15. Especialidades, estilo del negocio y lo que te diferencia.
        </span>
            </div>

            {/* Tiempo estimado de entrega */}
            <div className="ro-field">
                <label className="ro-lbl">
                    Tiempo estimado de entrega<span className="ro-req">*</span>
                </label>
                <p className="ro-hint" style={{ marginBottom: 10 }}>
                    ¿Cuánto tarda en promedio tu negocio en preparar un pedido?
                </p>
                <div className="ro-time-grid">
                    {TIME_OPTIONS.map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            className={`ro-time-opt${formData.estimated_time === opt.value ? ' ro-time-opt--active' : ''}`}
                            onClick={() => handleChange('estimated_time', opt.value)}
                        >
                            <span className="ro-time-opt-label">⏱ {opt.label}</span>
                            <span className="ro-time-opt-hint">{opt.hint}</span>
                        </button>
                    ))}
                </div>
                {errors.estimated_time && (
                    <span className="ro-err-msg">{errors.estimated_time}</span>
                )}
            </div>
        </div>
    );
};

export default StepRestaurantBasicInfo;
